<template>
<div>
    <Modal
        :value="setAdminModel"
        title="修改密码"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        >
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
                <Tabs type="card"  v-model="tabIndex">
                <TabPane label="修改密码" name="1">
                    <FormItem label="旧密码" prop="old_password" >
                        <Input  v-model="formData.old_password" type="password"></Input>
                    </FormItem>
                    <FormItem label="新密码" prop="new_password">
                        <Input type="password" v-model="formData.new_password"></Input>
                    </FormItem>
                    <FormItem label="确认新密码" prop="repeatpwd">
                        <Input type="password" v-model="formData.repeatpwd"></Input>
                    </FormItem>
                </TabPane>
                 </Tabs>
                 <FormItem>
                    <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
                </FormItem>
            </Form>
    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param dataRow  Object  点击的单条数据
 * @param setAdminModel boolean 对话框开关 true false  退款状态
 * @param fn function 回调函数
 */
import common from '@/common/common.js';
import SearchSelect from '../common/searchSelect';
import moment from 'moment';
    export default {
        props:{
            row: Object, // 当前点击的 那条数据 （对象）
            setAdminModel: Boolean,
            fn:Function,
            dataRow: Object,
        },
        components: {
            SearchSelect,
        },
        name: "Modelamdin",
        data () {
            var pwds = function(rule, value, callback){
                var reg = /^[0-9a-zA-Z]{6,10}$/;
                if(value != ''){
                    if(!value){
                        return callback(new Error("请输入密码"));
                    } else if (reg.test(value)==false) {
                        return callback(new Error("密码格式为数字，字母，长度为6到10"));
                    }
                    else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            return {
                disabled:false,//禁用确定按钮
                tabIndex:"1", //标签显示页
                addBox:{//弹框组
                    adtype:0
                },
                formData: {//表单数据
                    old_password:"",
                    new_password:"",
                    repeatpwd:"",
                },
                ruleCustom: {//验证
                    old_password:[
                        {validator: pwds,trigger: 'blur'},
                    ],
                   new_password:[
                        {validator: pwds,trigger: 'blur'},
                    ],
                    repeatpwd:[
                        {validator: pwds,trigger: 'blur'},
                    ],
                }
            }
        },
        watch:{
            dataRow (newValue) {
            }
        },
        created(){
        },
        methods: {
            subData (name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        if(this.formData.new_password != '' && this.formData.repeatpwd != ''){{
                            if(this.formData.new_password != this.formData.repeatpwd){
                            common.msg('error','新密码与确认新密码不一致',()=>{this.disabled = false;})
                            return false
                        }
                        }}
                        this.axios.post(this.config.urlArray.usersPassword,this.formData).then((result) => {
                            console.log(result)
                            if(result.data.code == 1){
                                common.msg('success',result.data.message,()=>{
                                    this.disabled = true
                                    })
                                window.sessionStorage.clear(); //清空缓存

                                this.resetForm()
                                this.fn()
                                setTimeout(() => {
                                    this.$router.push({ name: 'login' })
                                }, 1500);
                            }

                        }).catch((err) => {
                            console.log('错误提示',err)
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                    }
                })
            },
            cancel () {//对话框关闭
                this.$emit('update:setAdminModel',false)
            },
            resetForm () {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.tabIndex = '1' // 重置标签页
                this.disabled = false;//恢复提交按钮为激活状态
                this.addBox.adtype = 0
            }

        }
    }
</script>
<style scoped>
.ivu-form .ivu-form-item-label{
    width:120px ;
    text-align: center !important;
    text-indent: 1px;
  }
  .ivu-form-item-content{
    margin-left: 120px !important;
  }
</style>
